import { END_POINTS } from "../constants/url";
import { CommonBody } from "../types/General";
import emptySplitApi from "../utils/rtk";

interface CommonResponseType {
  status: number;
  message: string;
  statusCode: number;
}



export const multilingualEngineApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getEngine: builder.query<
      CommonResponseType & { data: any },
      {
        search?: string;
        length?: number;
        start?: number;
      }
    >({
      query: ({ length, search, start }) => ({
        url: `${END_POINTS.multilingual}?start=${start}&length=${length}&search=${search}`,
        method: "GET",
      }),
    }),
    getEngineById: builder.query<
      CommonResponseType & { data: any },
      {
        id: number;
      }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.multilingual}${id}/`,
        method: "GET",
      }),
    }),
   
    updateStatus: builder.mutation<CommonResponseType, { body: any; id: number }>({
      query: ({ body, id }) => ({
        url: `${END_POINTS.multilingual}?id=${id}`,
        method: "POST",
        body,
      }),
    }),

   
  }),
});

export const {useLazyGetEngineByIdQuery,useLazyGetEngineQuery,useUpdateStatusMutation
} = multilingualEngineApi;
